import { render, staticRenderFns } from "./JointsConfiguratorTemplate.vue?vue&type=template&id=46a2184c&scoped=true"
import script from "./JointsConfiguratorTemplate.vue?vue&type=script&setup=true&lang=ts"
export * from "./JointsConfiguratorTemplate.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./JointsConfiguratorTemplate.vue?vue&type=style&index=0&id=46a2184c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46a2184c",
  null
  
)

export default component.exports